export default {
  language: "English",
  navBar: {
    nav: {
      home: "首页",
      tools: "使能工具",
      cases: "成功案例",
      cooperate: "生态合作",
      talents: "人才招聘",
      about: "关于我们",
      login: "登录注册",
    },
  },
  home: {
    banner1: "全数据驱动的设计优化平台",
    banner2: "能落地的云端设计优化平台",
    banner3: "多人/多机协同的设计优化平台",
    bannerEnglish1: "Pure Data-driven Design Optimization Platform",
    bannerEnglish2:
      "Practically Applicable Data-driven Design Optimization System",
    bannerEnglish3:
      "Multi-person/task collaborated Design Optimization Platform",
    description: {
      p1: "DADOS（Data-driven Design Optimization System,数驱优化平台）是一个为工程师以及研究人员打造的专业的优化设计云端系统。",
      p2: "DADOS以提高实际产品性能为根本目的，在充分考虑企业工程师以及研究人员的应用习惯和特点的基础上，",
      p3: "采用FBP（ Flow-Based Programming ）框架，零编程、拖拉拽操作模式，",
      p4: "支持用户自定义搭建求解流程，轻松实现工程实例的快速分析，",
      p5: "满足产品性能可信预测、参数关联分析、性能快速优化等多种工程实际问题。",
      p6: "",
    },
    funcItems: {
      title1: "流程扁平化",
      intro1: "零编程、自由组合、拖拽操作",
      introTitle1: "流程扁平化",
      title2: "算法定制化",
      intro2: "算法自定义、自开发算法添加",
      introTitle2: "算法定制化",
      title3: "计算机云端化",
      intro3: "免安装、云存储、共享资源",
      introTitle3: "计算机云端化",
      title4: "作业协同化",
      intro4: "多人、多任务、实时更新",
      introTitle4: "作业协同化",
    },
    advantage: {
      bigtitle1: "数据驱动的优化设计平台",
      bigtitle2: "DADOS优势",
      title1: "扁平流程",
      des1: "拖拽式流程搭建平台，流程模块化设计，组件化存储，项目化更新",
      card1:
        "平台提供了图形化、模块拖拽的方式搭建求解算法流，支持用户自主选择算法模块进行拖拽，整体求解流程直观、简洁。为用户量身打造最合适的工作平台。用户无需具备编码能力和算法调参经验，通过简单的拖拽即可完成复杂的数据分析与模型搭建。",
      title2: "算法集成",
      des2: "试验设计、代理模型、优化设计、序列加点、精度检验等多种算法集成平台",
      card2:
        "平台在流程的不同阶段，集成了解决常用工程和科研问题的流行算法组件。针对每一个算法组件，提供了多种参数的属性设置功能，用户可以选用默认属性，也可以根据实际情况对算法进行更改、调参。同时，也支持用户上传部署自己开发的算法组件，满足各类问题的处理场景。",
      title3: "云端远程",
      des3: "云端上传，数据存储，远程服务器高速计算",
      card3:
        "平台支持公有云和私有云两种部署方式，用户在本地搭建优化设计流程，在云端部署优化任务，后台自动计算求解，大幅降低用户的使用成本。数据采用本地录入或上传，云端存储，支持项目加密发布、数据归一化处理，确保用户数据的多重保护。",
      title4: "多人协同",
      des4: "支持云端协同办公，具备任务发布管理系统",
      card4:
        "项目采用PI负责的多人协同制，PI创建任务流程后，可将所创建流程共享至其他用户并为各个用户分配操作权限，不同用户（比如不同学科、不同领域的工程师）按照相应权限可查验和修改流程或相应组件，实现同一流程下的多任务、多学科、跨领域协同作业。",
    },
  },
  teamBar: {
    title: "产研协同、数驱优化、精益求精",
    year: "年",
    meg1: "设计技术积累",
    meg2: "资深研究团队",
    meg3: "国家发明专利",
    number: "余项",
  },
  tools: {
    bannerTitle: "使能工具",
    bannerText: "强大的算法组件，提供更优质的工程问题解决方案",
    title: "工具优势",
    getMore: "了解更多",
    toolsInfo: {
      title1: "试验设计",
      text1:
        "在给定空间内科学的布局样本点，利用尽可能少的采样次数获取更多的数据信息...",
      title2: "代理模型",
      text2:
        "包含目前常用的多种代理模型技术，能够基于样本信息，特别是小样本信息，构建线性、非线性的黑箱近似模型...",
      title3: "精度检验",
      text3:
        "针对构造的近似模型进行模型精度的快速评价，包括全局性能评价、局部性能评价等...",
      title4: "全局优化",
      text4:
        "集成多种先进的非梯度寻优算法，实现全局最优点的快速定位，同时考虑各种实际的约束条件...",
      title5: "敏度分析",
      text5:
        "旨在识别不同参数对性能的影响分量，揭示参数与参数之间的耦合机理、参数与性能之间的影响规律...",
      title6: "序列加点",
      text6:
        "在一次近似模型的基础上，引入置信度与期望改进等，设计序列样本，有效提高模型的全局探索和局部开发能力...",
    },
    dialogInfoList: {
      text1_1:
        "试验设计（Design of Experiment, DoE），属于数理统计的一个分支，讲究如何按照预定目标制订适当的实验方案，重点关注空间的覆盖性和均匀性，也就是用尽量少的样本点表达整体设计空间均匀性和填充性；",
      text1_2:
        "DoE的范围选择要根据实际问题而定，实现手段可以是物理实验，也可以是计算机实验，需要指出的是，DoE的样本点分布对代理模型的精度有很大影响；",
      text1_3:
        "常用的DoE包括正交实验法、拉丁超立方取样法、以及我国数学家方开泰先生创立的均匀设计法等。考虑到方法的实用性、相似性以及对后续多目标优化中交叉变量的处理，DADOS平台目前主要采用OA、CCD、LHS、OLHS等四种方法。",
      text2_1:
        "代理模型的作用是基于训练样本构建输入输出的相应关系，常用的代理模型包含多项式响应面法（PRS）等十余种；",
      text2_2:
        "鉴于每种代理模型各有优缺点，DADOS平台目前集成了PRS、RBF、KRG、MLS、SVR和ANN等七种流行的代理模型；",
      text2_3:
        "能够满足低维（<10）、高维（<100）、线性、弱非线性、强非线性等不同维度、不同类型函数的逼近；",
      text2_4:
        "代理模型的精度直接决定了优化及分析结果，建议实际使用前了解不同代理模型的适用性；",

      text3_1:
        "代理模型的精度检验是关键一步，是评价能否基于此代理模型进行后续参数分析与优化设计的关键一步；",
      text3_2:
        "检验方法的指标分为全局性能和局部性能两大类，前者评估模型在整个设计域上的逼近能力，后者评估在局部感兴趣区间上的逼近能力；",
      text3_3:
        "考虑DADOS平台的非大样本或大数据特性，精度检验采用改进的K-折、留一法等精度校验方法，以满足一般工程问题需求。",
      text4_1:
        "优化设计的目的是提高产品的性能指标，实际工程优化问题往往兼具多目标、多约束、多参数以及多学科等特性，DADOS平台在充分调研和分析的基础上，优中选优，提供了改进的遗传算法、粒子群算法、模拟退火法等进化算法，能够满足无约束、有约束、单目标、多目标、多学科优化等需求；",
      text4_2:
        "DADOS创新地提出“合-分-合”的多层级分流再融合的优化流程和策略，采用一套DoE取样策略，对不同学科和目标进行数据的采样和代理模型构建，然后在优化器中进行总体优化求解，避免了复杂问题中交叉变量的解耦难题。",
      text5_1:
        "敏感性分析是一种定量描述模型输入变量对输出变量的重要程度的方法，根据作用可以分为全局敏感性分析和局部敏感性分析；",
      text5_2:
        "DADOS平台目前包含傅里叶敏感性检验法、Sobol等敏感性分析算法，能够评价单个因素的影响程度，也能评价多个因素的交叉影响程度；",
      text5_3:
        "获取每个参数的敏感性系数，有利于揭示性能的变化规律，并有针对性的进行降维、数据增补等处理，可以大幅降低模型的复杂程度，减少数据分析和优化的工作量。",
      text6_1:
        "序列加点法是一种在已有样本信息以及近似模型的基础上，通过合理的新增样本信息，来实现样本空间的均匀填充以及代理模型的不断优化；",
      text6_2:
        "DADOS平台目前包含概率提升（PoI）、期望提升（EI）、最小均方根误差（RMSE）等序列加点法，后期会引入围棋启发式组合策略（GO-HI）等多种新型序列加点法；",
      text6_3:
        "小样本情况下，序列加点法会有效改善样本空间分布，提高模型精度；但是在样本数较大以及特定问题上，现有序列加点法也容易陷入局部点，即在感兴趣区间不断重复采样。",
    },
  },
  cases: {
    bannerTitle: "成功案例",
    bannerText: "应用于工程实际问题，为工程师们提供一体化工具",
    caseInfoList_1: "核电安全阀",
    caseInfoList_2: "汽车控制臂",
    caseInfoList_3: "激光切割",
    caseInfoList_4: "燃料电池",
    caseInfoList_5: "旋转轮体",
    caseInfoList_6: "无人机",
    caseInfoList_7: "TPC",
    caseInfoList_8: "大型压力机",
    caseInfoList_9: "核燃料组件",
    caseInfoList_10: "特斯拉阀",
    caseInfoList_11: "人体骨骼",
    caseInfoList_12: "夹层结构",
    caseInfoList_13: "盾构机",
    caseInfoList_14: "More",
    case1: {
      p1: "安全阀作为压力系统中超压保护的最后一道屏障，被广泛用于锅炉、压力容器和压力管道。安全阀通常处于常闭状态，当设备或管道内的介质压力超过规定值时会自动开启，通过泄压来防止管道或设备内的压力超过规定数值。",
      p2: "本研究对安全阀阀盘结构进行优化设计，优化列式如下",
      p3: "其中优化目标是最大化安全阀出口质量流量，优化参数有三个，分别是阀盘半径，喷嘴半径以及阀盘深度。优化设计完全基于代理模型技术完成，包括：拉丁超立方的取样方法、RBF预测模型和遗传优化算法。",
      p4: "优化设计与初始设计对比，阀盘半径减小了",
      p5: "，阀盘深度减小了",
      p6: "，阀盘凸边厚度减小",
      p7: "优化设计与初始设计对比，出口的流量增大了",
      p8: "，比初始状态增大",
    },
    case2: {
      p1: "在汽车悬架中，上部控制臂是位于车架和后桥壳之间的汽车悬架部件，用于承载制动和驱动力矩。上肢的主要功能是管理车轮的运动与车辆的身体。随着对总成重量、成本和燃油效率的要求越来越高，设计重量更轻、性能更强的上肢控制臂成为必要和流行。",
      p2: "针对上述6个设计尺寸中的变量，以轻量化汽车控制臂为设计目标，成功实现控制臂的轻量化设计，在不牺牲力学性能的同时，减重",
      p3: "。",
    },
    case3: {
      p1: "激光切割是一种用于去除材料的加工方法，具有切割效率高、加工范围广、加工柔性大等优点，广泛应用于机械、钢铁、汽车、航空航天等工业领域。激光切割质量受到激光功率、切割速率、辅助气体种类及压力等加工参数的影响。评价激光切割质量的一个重要指标是挂渣量，挂渣指的是在切割过程中辅助气体未能将熔融金属彻底吹出，而在切口下缘附着的熔渣。本研究为获得最少的挂渣量对激光切割的加工参数进行了优化，优化列式如下：",
      p2: "其中，优化目标是最小化挂渣重量，优化约束有4个，包括激光切割功率、切割速率、辅助气体压力的加工范围和保证切透加工材料的功率速率比。设计变量是激光功率、切割速率和辅助气体压力。",
      p3: "利用kriging建立的挂渣重量预测模型分析了激光功率、切割速度和辅助气压等加工参数对挂渣量的影响规律。DoE采用拉丁超立方抽样方法，训练样本点30个，测试样本点25个。",
      p4: "优化后的加工参数与初始加工参数相比，所得挂渣重量减少了",
      p5: ",可以满足“无挂渣”的切割质量要求。",
    },
    case4: {
      p1: "燃料电池工作的基本原理就是燃料与氧化剂发生氧化还原反应，反应过程中会伴随有电能产生。PEM燃料电池主要由双极板、气体扩散层、催化层和PEM组成。",
      p2: "基于代理模型的HT-PEM燃料电池的优化方法",
      p3: "创新之处",
      p4: "：",
      p5: "· 构建了不同操作条件和流场结构下电池性能的代理模型，直观分析不同设计参数对电池性能的影响。",
      p6: "· 结合优化算法得到固定活化面积下的最佳流道设计。",
      p7: "优化列式如下：",
      p8: "HT-PEM渐变结构分析优化设计:",
      p9: "· 渐变流道设计的电流密度得到显著改善，流道间的肋下对流也明显加强。",
      p10: "· 空气浓度分布更加均匀，活化面积中缺氧的部分明显减少。",
      p11: "· 进行渐变流道设计的电流密度和实际功率分别增长了",
      p12: "和",
      p13: "。",
    },
    case5: {
      p1: "在矿产业中，大型矿井提升机是最常用的矿山设备，它担负着矿井的矿产、工作人员、各种材料和设备的提升、下降等运送任务，是矿产业中极为重要的组成部分。天轮作为大型矿井提升机主要的受力承载体，在整个提升过程保证钢丝绳在摩擦轮上的围包角以及导向的平稳性能，其性能直接影响着整个提升系统。随着大型矿井提升机的需求向高速、稳定、重载、超压等方向发展，为应对更加复杂和更大负载的工况，保证其强度和稳定性，天轮的直径在不断增大，质量也随之增加。但是这不仅带来材料和能源消耗的增加，也使天轮的运输、安装及维护更加不便，同时也使天轮主轴等部件的负载增加，造成了一定的安全隐患。本研究针对天轮进行了结构优化设计，优化列式如下：",
      p2: "其中，优化目标是质量量最小化，优化约束分别为：轮体应力和变形，设计参数是轮辐工艺孔各尺寸。",
      p3: "优化设计（或者敏感性分析）完全基于代理模型技术完成，使用了 RBF 代理模型， DOE 采用最优拉丁超立方抽样方法，初始采样点",
      p4: "，采用交叉验证方法验证代理模型精度。",
      p5: "通过优化，轮体的重量从原来的",
      p6: " 降低为 ",
      p7: "减重了",
    },
    case6: {
      p1: "无人机大多是旋翼无人机，通过旋翼叶片的高速转动，为无人机提供升力，通过多个电机的配合，从而实现空中前进、后退、翻转等复杂动作。螺旋桨叶片对无人机功率会产生重要影响，进而影响无人机飞行。因此，需要考虑到的最重要因素之一就是飞行效率。",
      p2: "本研究对无人机叶片轻量化为目标进行优化设计，优化列式如下:",
      p3: "本研究Doe采用了拉丁超立方的取样方法选取了200个样本点进行代理模型的搭建，使用了RBF预测模型并使用遗传算法进行优化;成功实现无人机叶片的轻量化设计，在同等负载条件下，续航力提高",
      p4: "。",
    },
    case7: {
      p1: 'The need for "net zero" targets urged the development of carbon capture, utilisation, and storage (CCUS) technologies, among which CO2 capture via enhanced weathering (EW) of mineral particles could potentially absorb atmospheric CO2 at gigaton scale per year and store as bicarbonate and carbonate in the ocean.',
      p2: "However, this process must be operated in engineered reactors under controlled condition to minimise the energy and water consumption at the maximum CO2 capture rate. In this work, physics-based simulations of two types of chemical contactors, namely, trickle bed (TB) and packed bubble column (PBC) reactors, were developed. Based on the data generated by the physical-based simulations, two data-driven surrogate models, namely the response surface methodology (RSM) and extended adaptive hybrid functions (E-AHF), were developed and compared, in which the relationship of five design variables and three objective functions was investigated.",
      p3: "Results showed that the prediction of CO2 capture rate and water consumption through RSM and E-AHF are both highly accurate.",
      p4: "Nevertheless, the prediction accuracy of energy consumption was improved by the E-AHF model. After optimization, the maximum CO2 capture rate was improved to 1.8163 kg h-1 by TB reactor, the minimum water consumption and energy consumption were reduced to 5.416 m3 kg-1CO2 (PBC reactor) and 0.1316 MJ kg-1CO2 (TB reactor), respectively.",
    },
    case8: {
      p1: "压力机是一种结构精巧的通用性设备。具有用途广泛，生产效率高等特点，结构的最大变形量是轻量化的重要性能指标。本研究针对大型压力机进行了结构优化设计。",
      p2: "本次优化目标是轻量化，要在保持变形量的情况下，使得模型的重量最小。建立如下的数学模型为",
      p3: "其中，优化目标是最小化f(P)，优化约束有5个，包括P1,P2,P3,P4,P5。P1,P2,P3,P4是设计参数,P5为最大变形量。优化设计完全基于代理模型技术完成，使用了Kriging代理模型，Doe采用拉丁超立方的方法，初始采样点40个。",
      p4: "在保证变形量的情况下，优化设计与初始化设计对比，上梁质量减少了",
      p5: "。减重",
      p6: "吨。在压力机所具有四个上梁中，上梁部分一共减重",
      p7: "吨。",
    },
    case9: {
      p1: "燃料组件是核反应堆的核心部件，同时也是核反应堆内的释热部件，对反应堆内燃料的稳定性起着重要作用。其中，各个燃料芯体之间温度分布的不均匀性是燃料组件正常工作的重要性能指标。本研究针对燃料组件的冷却流道宽度进行了结构优化设计",
      p2: "其中，优化目标是最小化各个燃料芯体之间温度分布的不均匀性（各个燃料芯体最高温度的标准差，T_Fuel_SD），优化约束有11个，包括综合指标R（各个冷却流道冷却液努塞尔数与达西摩擦系数之间的比值，R_AV），燃料组件的最高温度（T_Fuel_MAX），燃料组件最大等效应力（S_MAX），各个冷却流道的宽度（L1,L2,⋯,L8）,优化设计参数为各个冷却流道的宽度（L1,L2,⋯,L8）。",
      p3: "优化设计完全基于代理模型技术完成，使用了Kriging代理模型，DoE采用拉丁超立方方法，初始采样点80个，共耗时36小时。",
      p4: "优化后结果与初始值相比，燃料芯体最高温度降低",
      p5: "，燃料组件最大节点应力下降",
      p6: "，综合指标（努赛尔数与阻力系数之比）降",
      p7: "，各燃料芯体最高节点温度标准差降低",
      p8: "，各燃料芯体最高温度分布的不均匀性明显降低。",
    },
    case10: {
      p1: "特斯拉阀是一种被动式流体控制装置，结构由直道和弯道构成，该结构设计使正向流动相对于反向流动更加容易，达到控制流动效果。特斯拉阀能够在各种尺度下正常工作，性能稳定。由于其可缩放性，以及无需能源的特性，现在特斯拉阀门已被运用于微流体控制、微电子机械系统、生物技术和分析化学等领域，在微流体领域中具有广泛的应用前景。Diodicity(Di)是描述特斯拉阀性能的关键指标，其定量的刻画了阀门控制流动流向的能力。因此本研究中将其作为优化目标，对特斯拉阀进行结构优化，优化列式如下：",
      p2: "其中，选择侧通道的直线段的长度L，侧通道与主通道之间的角度α，内部曲线与主通道的切线之间的角度β以及通道宽度W作为设计变量，以寻求最佳设计。优化设计完全基于代理模型技术完成，使用LHS方法作为DoE策略，从设计空间中提取用来构建代理模型的样本点。通过比较多种代理模型的对于本问题的拟合精度，最终选择使用Kriging模型来近似输入与响应之间的关系。",
      p3: "优化结果表明，与文献中现有的最优设计相比，基于代理模型优化后的特斯拉阀的止回特性仍提高了",
    },

    case11: {
      p1: "腰疼的原因可能有血管、机械或神经等因素，其中腰椎不稳症（lumbarinstability）是造成腰疼的较为主要因素。腰椎小关节作为微动关节来连接相邻的腰椎构成运动节段，不同节段小关节面的朝向决定其各自可能的运动方式，承载着压力、牵拉、剪切和扭转等负荷。本研究的研究对象设定为参与试验者的L2-L5段椎间盘，包括其上的纤维环、髓核等。针对此段椎间盘建立有限元模型并对小关节角度对腰椎的影响进行了敏感度分析。",
      p2: "研究对象设定为参与试验者的L2-L5段椎间盘，包括其上的纤维环、髓核等。针对此段椎间盘建立有限元模型并分析小关节角度对腰间盘应力的影响。",
      p3: "运用PRS模型建立小关节方向（FO）和小关节向性（FT）与小关节接触力的关系，并通过Sobol's法进行全局敏感度分析，采用5万蒙特卡洛样本点进行计算，分析表明：",
      p4: "小关节方向（FO）",
      p5: "和",
      p6: "小关节向性（FT）",
      p7: "是复发性腰间盘突出的危险因素，FO越小，FT越大越容易复发。",
    },
    case12: {
      p1: "蜂窝夹层结构作为一种航空航天行业中常见的火箭外壳结构，在固化过程中由于材料的热膨胀和树脂的收缩而引起的夹层结构的变形回弹，从而影响火箭外壳装配精度的下降。夹层结构的收缩量以及圆度误差是影响火箭外壳装配的重要性能指标。本研究针对支撑形式进行了优化设计",
      p2: "本研究对安全阀阀盘结构进行优化设计，优化列式如下:",
      p3: "其中，优化目标是最小化内表面的变形值，优化约束有2个，设计参数为支撑与模具圆心的角度。本研究还对圆度误差和收缩量进行了参数敏感度分析，该分析完全基于代理模型技术完成，使用了RBF模型，Doe采用最优拉丁超立方的方法，初始采样点100个。",
      p4: "通过敏感度分析：模具的热膨胀系数和面板的热膨胀系数是影响夹层结构收缩的主要因素。树脂的热膨胀系数是影响圆度误差最主要的因素。",
      p5: "结果表明：模具的热膨胀系数和面板的",
      p6: "热膨胀系数",
      p7: "是影响夹层结构收缩的主要因素。树脂的",
      p8: "热膨胀系数",
      p9: "是影响圆度误差最主要的因素。",
    },
    case13: {
      p1: "隧道掘进机（Tunnel Boring Machine,TBM）是一种专门用于隧道挖掘的大型复杂机电设备，主要用于城市地铁、矿山开采、地下管线隧道等工程建设。该设备具有一次开挖完成隧道的特点，开钻、掘进、支护、出渣等施工工序并行连续作业，具有掘进速度快、环保、综合效益高等优点，可实现传统钻爆法难以实现的复杂地理地貌深埋长隧洞的施工。",
      p2: "基于代理模型方法对TBM刀盘驱动系统输出特性小齿轮-齿圈啮合力的动态偏差值进行全局敏感度分析（GSA）。在考虑10个系统参数的情况下，利用Sobol全局敏感度分析方法，得到系统动力学特性对多个系统参数的全局敏感度。研究全局敏感度较高的参数对系统动力学特性的影响规律，为TBM刀盘驱动系统动力学设计提供依据。",
      p3: "结果表明：",
      p4: "小齿轮-齿圈啮合力的动态偏差值几乎仅受系统联接阻尼参数的影响，其全局敏感度指数达到",
      p5: "82.2%",
      p6: "；",
      p7: "齿圈啮合节点处振动位移均方根值主要受系统联接刚度参数影响，其全局敏感度指数约为",
      p8: "74.3%",
      p9: "，而轴向推力的全局敏感度指数约为",
      p10: "11.1%",
      p11: "；",
      p12: "小齿轮啮合节点处最大扭转振动加速度主要受刀盘扭矩负载和联接阻尼参数的影响，两者的全局敏感度指数分别为",
      p13: "54.2%",
      p14: "和 ",
      p15: "41.7%",
      p16: "。",
    },
  },
  cooperate: {
    bannerTitle: "生态合作",
    bannerText: "加入DADOS应用与开发，携手并进，助推中国制造发展…",
    title: "生态合作",
    title1: "合作伙伴",
    cardInfoList: {
      title1: "技术培训",
      title2: "项目支持",
      title3: "市场营销",
      title4: "联合开发",
      text1:
        "开展DADOS平台及基于代理模型优化等方面的培训和交流，为用户详细介绍软件系统和底层算法，提升企业产品设计研发能力。",
      text2:
        "承接产品建模、分析、优化等方面课题，提供一对一专业咨询服务，实现产品最优化设计，满足高端市场竞争需求。",
      text3:
        "分工合作，积极推广，与DADOS团队共同或者独立拓展产品应用市场和应用领域，引导企业用户熟悉、掌握产品优化流程和软件。",
      text4:
        "欢迎有识之士加入DADOS开发团队，我们共同成长，打造自主工业软件，即使像蜗牛一样缓慢爬行，只要心怀梦想，终能见彩虹。",
      activeText1:
        "提供专业的技术培训，详细讲解DADOS软件平台以及基于代理模型的优化设计理论和方法，通过已有成功案例讲解，帮助企业工程师迅速、深入掌握平台以及代理模型优化的使用方法，实现目标产品的精益优化。",
      activeText2:
        "DADOS开发团队拥有十几年的产品优化设计经验和基础，已经成功完成了机械、能源、化工、汽车、航天等多个领域和企业产品的优化设计。秉持着“百尺竿头更进一步”的精益优化信条，为客户打造高端产品的专属优化设计方案。",
      activeText3:
        "DADOS的发展离不开市场与用户，离不开中国制造，我们期待开展市场联合营销与推广活动，始终以用户需求为导向，不断进行用户体验调查与提升，促进DADOS系统平台不断更新升级。",
      activeText4:
        "千里之行始于足下。DADOS只是工业软件中的“小蜗牛”，我们希望联合高校、科研院所、企业等一切可以联合的力量，不断完善DADOS核心算法与平台，群策群力，携手并进，建立合作共赢的开发合作生态环境，打造优化设计领域的中国品牌。",
    },
  },
  talents: {
    bannerTitle: "人才招聘",
    bannerText: "DADOS团队诚邀您的加入！",
    title1: "人才招聘",
    titleText:
      "竭诚欢迎海内外优秀学子加盟大连理工大学机械工程学院和 DADOS开发团队！",
    tipBlock: {
      tipTitle1: "研究领域",
      tipTitle2: "申请条件",
      tipTitle3: "聘期",
      tipTitle4: "申请条件",
      tipTitle5: "薪酬及待遇",
      tipTitle6: "博士后公寓",
      tipTitle7: "职称资格认定",
      tipText1: {
        p0: "多学科优化设计",
        p1: "智能代理模型技术",
        p2: "大数据与人工智能",
        p3: "不确定性优化",
        p4: "进化优化算法",
      },
      tipText2: {
        p0: "具有良好的政治思想素质、道德品质和学术诚信，热爱科研、有团队精神；",
        p1: "从事过优化设计或工业大数据研究工作；",
        p2: "年龄35岁以下，身体健康；",
        p3: "获得博士学位不超过4年；",
        p4: "在国内外知名高校取得博士学位，985大学毕业及有海外科研经历者优先；",
        p5: "能够保证全职在校从事博士后研究工作 ，人事关系转入大连理工大学；",
      },
      tipText3: {
        p0: "聘期2年，表现优秀者，根据研究需要和双方协商，可续聘。",
      },
      tipText4: {
        person0: "(1) 特别资助博士后",
        person1: "(2)专职科研博士后（分A、B、C档）",
        describe0:
          "依托国家博士后国际交流引进计划以及“博新计划”等国家专项计划进行招收，主要招收海外世界排名前100名高校（或学科）的博士毕业生或其他业绩特别突出的博士毕业生。",
        describe1:
          "招收对象为海内外高水平大学毕业且综合业绩突出的优秀博士毕业生。A、B、C三个档级通过学校评审划分。",
      },
      tipText5: {
        title1: "待遇：",
        title2: "薪酬标准分别为：",
        p0: "博士后聘期内是具有流动性质的科研工作人员，在站期间计算工龄。可以办理短期常住户口，聘期内纳入大连理工大学职工人事管理、工资管理和社会保障体系，在子女入托、入学等方面享受学校职工同等待遇。",
        p1: "博士后聘期内实行年薪制，包含基本薪酬，奖励性绩效，五险二金。基本薪酬和五险二金由大连理工大学提供；奖励性绩效由流动站所在学院研究所根据博士后业绩进行核放。",
        p2: "(1) 特别资助博士后，年人力资源成本（含基本薪酬、奖励性绩效、五险二金，下同）不低于40万。",
        p3: "(2) 专职科研博士后：",
        p4: "A类：年人力资源成本不低于30万；",
        p5: "B类：年人力资源成本不低于25万；",
        p6: "C类：年人力资源成本不低于20万（需合作导师提供部分经费）。",
      },
      tipText6: {
        p0: "全职在校工作的博士后人员，首个聘期内可申请租住价格优惠的学校博士后公寓。",
        p1: "续聘期间，薪酬由学校承担的续聘人员租住价格不变，其他续聘人员按学校博士后公寓的正常租住价格执行。",
      },
      tipText7: {
        p0: "博士后进站后予以认定中级职称资格；工作期满，业绩优秀且被流动站所在二级单位确定为拟留校人选者，可以参加学校组织的专业技术人员特殊评审。其他人员可以参加副高级专业技术职务任职资格评定。",
        p1: "博士后人员出站后实行双向选择、自主择业。如申请学校教职，选聘条件和程序按大连理工大学引进人才相关规定执行。",
      },
    },
  },
  about: {
    bannerTitle: "关于我们",
    bannerText: "产研协同、数据优化、精益求精",
    title1: "团队介绍",
    title2: "团队实力",
    p1: ",数驱优化",
    p2: "（",
    p3: "，数据驱动优化设计系统）是大连理工大学机械工程学院重大装备设计研究所开发的专业化、云端的产品优化设计平台。开发团队由宋学官教授（国家杰青、青千、重点研发计划首席科学家）领衔，团队包括教授、副教授、博士研究生、硕士研究生以及资深IT工程师等人员近20人。",
    p4: "团队具有近20年的重大装备和关键零部件分析、设计与优化经验，先后主持或参与了国家重点研发计划、973、自然基金委重点基金项目、辽宁省重大专项、山西省重大专项项目等科研攻关项目数十项，为数十家知名企业和科研院所提供了技术服务，涵盖工程机械、核电、新能源、航空/航天、核心零部件制造、医疗健康等众多行业，为多个企业定制开发了产品设计和优化软件，获批国家发明专利和软件著作权20余项，得到了合作单位的高度认可和信赖。",
    p5: "团队始终秉承“产研协同、数驱优化、精益求精”的科研使命，虽慢不怠，在复杂产品的建模仿真、数字化设计、多学科优化、数字挛生、装备智能化等科研领域深耕细作，坚持理论创新、坚持算法突破、坚持从实际问题出发、坚持以落地为目标。同时，紧跟国家制造业数字化转型步伐，布局工业互联网、智能制造等关键领域，旨在改变传统设计模式，在设计阶段就充分挖掘和发挥工业多源数据（仿真数据、实测数据等）的联合驱动力，助推中国装备从无到有、从有到优、从优到特的跨越式发展和突破。",
  },
  footer: {
    location:
      "大连市高新园区凌水路2号 大连理工大学 机械工程学院 重大装备设计研究所",
    email: "联系邮箱：service@dados.com.cn",
    bei: "辽ICP备2020014352号",
  },
};



// WEBPACK FOOTER //
// ./src/lang/zh.js